import { useSelector } from 'react-redux';
import { Outlet, Navigate, useLocation } from 'react-router-dom';

import { LoadingPage } from '@components/Loader/Loader';
import { Sentry } from '@config';

const PrivateRoutes = () => {
  const { isAuthenticated, isLoading, user } = useSelector(
    (state) => state.auth
  );

  const location = useLocation();
  if (isLoading) {
    return <LoadingPage className="login-body" />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  Sentry.setUser(user);
  return <Outlet />;
};

export default PrivateRoutes;
